import React, { useState } from 'react';
import Past from './Past';
import Upcoming from './Upcoming';

const EventScreen = () => {
  const [active, setActive] = useState(0);

  return (
    <div className="px-5 align-center items-center ">
      <div className="text-2xl font-semibold text-black">My Events</div>
      {/* Tabs */}
      <div className="flex border-b border-gray-300">
        <button
          onClick={() => setActive(0)}
          className={`flex-1 py-4 text-center border-b-2 ${
            active === 0 ? 'border-pink-500 text-pink-500 font-semibold' : 'border-transparent text-gray-500'
          }`}
        >
          Upcoming
        </button>
        <button
          onClick={() => setActive(1)}
          className={`flex-1 py-4 text-center border-b-2 ${
            active === 1 ? 'border-pink-500 text-pink-500 font-semibold' : 'border-transparent text-gray-500'
          }`}
        >
          Past Events
        </button>
      </div>

      {/* Tab Content */}
      <div className="p-4">
        {active === 0 ? <Upcoming /> : <Past />}
      </div>
    </div>
  );
};

export default EventScreen;
